/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';
import { CreateAppDto } from '../../models/create-app-dto';

export interface AppControllerCreate$Params {
      body: CreateAppDto
}

export function appControllerCreate(http: HttpClient, rootUrl: string, params: AppControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, appControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

appControllerCreate.PATH = '/app';
